import { render, staticRenderFns } from "./userHandsel.vue?vue&type=template&id=10746678&scoped=true&"
import script from "./userHandsel.vue?vue&type=script&lang=js&"
export * from "./userHandsel.vue?vue&type=script&lang=js&"
import style0 from "./userHandsel.vue?vue&type=style&index=0&id=10746678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10746678",
  null
  
)

export default component.exports